module.exports = __webpack_public_path__ + "static/bg-3e676c72cf8d28a70d310d2417e09b98.jpg";